import { hasPaymentMethodCardExpired, getPaymentMethodLabel } from '@/utils/residents/paymentUtils';

export const getStableMethodKey = (method: any): string => {
  const key = method?.id ?? method?.sourceId ?? null;
  if (key !== null && key !== undefined) return String(key);
  // Last resort: derive from label and last4 (relatively stable)
  const label = getPaymentMethodLabel(method);
  const last4 = method?.last4 ? String(method.last4) : '';
  return `${label}:${last4}`;
};

export const classifyPaymentMethods = (
  paymentMethods: any[] = [],
  selectedMethodId?: string | number,
) => {
  const selectedMethod = (() => {
    if (!selectedMethodId || !paymentMethods.length) {
      return paymentMethods.find((m) => m.isDefault) || paymentMethods[0];
    }
    return paymentMethods.find((m) => m.id === selectedMethodId || m.sourceId === selectedMethodId);
  })();

  const expiredMethods = paymentMethods.filter((m) => hasPaymentMethodCardExpired(m?.expiry));
  const blockedMethods = paymentMethods.filter((m) => Boolean(m?.blockedAt));
  const availableMethods = paymentMethods.filter((m) => !hasPaymentMethodCardExpired(m?.expiry) && !Boolean(m?.blockedAt));

  const hasValidMethods = availableMethods.length > 0;
  const allMethodsExpired = paymentMethods.length > 0 && availableMethods.length === 0;

  return {
    selectedMethod,
    availableMethods,
    expiredMethods,
    blockedMethods,
    hasValidMethods,
    allMethodsExpired,
    totalMethods: paymentMethods.length,
  };
};


